/**
 * Core Search JS entry.
 *
 * Loaded on both search and archive pages.
 */
import { ComponentManager } from 'js-component-framework';

// Import facet js.
import SearchFacets from './search';

// Import SCSS
import './search.scss';

const searchFacets = {
  name: 'SearchFacets',
  class: SearchFacets,
  querySelectorAll: {
    // eslint-disable-next-line max-len
    controls: '.elasticsearch-extensions__select-control select, .elasticsearch-extensions__checkbox-group input',
  },
};

const manager = new ComponentManager('entrepreneurship');

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents([
    searchFacets,
  ]);
});

if (module.hot) {
  module.hot.accept();
  manager.initComponents([
    searchFacets,
  ]);
}
